//Import Images
import {
  hoobank_small,
  vidoeGame_small,
  hoobank2_small,
  videoGame2_small,
  sprout_scribble_small,
} from "./img";

export const MovieState = () => {
  return [
    {
      title: "The Hoobank",
      mainImg: hoobank_small,
      secondaryImg: hoobank2_small,
      url: "/work/the-hoobank",
      websiteUrl: "https://hoobank-rho.vercel.app/",
      awards: [
        {
          title: "About the project",
          description:
            '"A modern, responsive banking application built with React and Vite, featuring a beautiful Tailwind CSS design."',
        },
        {
          title: "Technology Stack",
          description:
            '"Built with React, JavaScript, and Tailwindcss for a modern UI."',
        },
        {
          title: "Key Features",
          description:
            '"Modern and responsive design, Beautiful Tailwind CSS styling, Mobile-first approach"',
        },
      ],
    },
    {
      title: "The Game Hub",
      mainImg: vidoeGame_small,
      url: "/work/the-vidoeGame",
      secondaryImg: videoGame2_small,
      websiteUrl: "https://video-game-five.vercel.app/",
      awards: [
        {
          title: "About the project",
          description:
            '"A responsive and interactive React + TypeScript application for exploring Android Indie Games."',
        },
        {
          title: "Technology Stack",
          description:
            '"Built with React, TypeScript, and Chakra UI for a modern UI."',
        },
        {
          title: "Key Features",
          description:
            '"Includes search with filtering, responsive UI for mobile and desktop, and dark mode support."',
        },
      ],
    },
    {
      title: "Sprout-scribble",
      mainImg: sprout_scribble_small,
      url: "/work/the-sprout-scribble",
      websiteUrl: "https://sprout-scribble-gamma.vercel.app/auth/login",
      awards: [
        {
          title: "About the project",
          description:
            '"A fully responsive and modern E-commerce application which is built with the latest technologies"',
        },
        {
          title: "Technology Stack",
          description:
            '"React, Nextjs, Typscript, Tailwindcss, shadcn, PostgreSQL, Drizzle ORM"',
        },
        {
          title: "Key Features",
          description:
            '"Includes AI-powered search, secure Stripe payments, and social login (GitHub & Google)"',
        },
      ],
    },
  ];
};
